import { BaseError } from "./BaseError";

export class NoResponseDataError extends BaseError {

    private static readonly DEFAULT_MESSAGE: string = 'Response returned no data'

    constructor(message: string = NoResponseDataError.DEFAULT_MESSAGE) {
        super(message);
    }

}